export function formatIncomingMessagePreview(msg) {
  const messageType = String(msg?.message_type || '').trim();
  const meta = msg?.meta || {};

  if (messageType === 'reaction') {
    const emoji = String(meta?.message?.reaction?.emoji || '').trim();
    return emoji ? `${emoji} Reaksiyon` : 'Reaksiyon';
  }

  if (messageType === 'button') {
    const button = meta?.message?.button || {};
    const text = String(button.text || '').trim();
    const payload = String(button.payload || '').trim();
    return text || payload || 'Buton yanıtı';
  }

  if (messageType === 'interactive') {
    const interactive = meta?.message?.interactive || {};
    const buttonReply = interactive.button_reply || {};
    const listReply = interactive.list_reply || {};
    const title = String(buttonReply.title || listReply.title || '').trim();
    const description = String(listReply.description || '').trim();
    const fallbackId = String(buttonReply.id || listReply.id || '').trim();
    return title || description || fallbackId || 'Buton yanıtı';
  }

  return msg?.body || '-';
}
